import { useState } from "react";

const faqs = [
  {
    question: "What is Paladin Professional Insurance Solutions?",
    answer:
      "Paladin Professional Insurance Solutions is a full-service independent insurance agency based in Ventura, CA. We specialize in delivering premium protection across personal, commercial, and specialty lines. Our consultative, hands-on approach means we craft coverage that truly fits your life and your business — not a generic, off-the-shelf policy.",
  },
  {
    question: "What makes Paladin different from other insurance agencies?",
    answer:
      "Paladin is an independent agency, meaning our agents aren't tied to a single insurance carrier. With over 20 years of industry experience, we shop across multiple providers to find you the best coverage at the best price. We take a family-first, consultative approach — treating every client the way we would our own family.",
  },
  {
    question: "How long has Paladin been in the insurance industry?",
    answer:
      "Our agents bring over 20 years of experience in the insurance industry. This deep expertise allows us to navigate complex coverage options and match clients with the right policies across a wide range of personal, commercial, and specialty lines.",
  },
  {
    question: "Is Paladin an independent insurance agency?",
    answer:
      "Yes. Paladin is a fully independent insurance agency. This means we are not bound to any single insurance carrier, allowing us to compare multiple providers on your behalf and find the most competitive coverage tailored to your specific needs.",
  },
];

function FaqItem({ question, answer, isOpen, onToggle }) {
  return (
    <div
      className={`border transition-all duration-200 overflow-hidden ${
        isOpen
          ? "border-blue-dark border-opacity-25 bg-white-pure shadow-sm"
          : "border-blue-dark border-opacity-8 bg-white-pure bg-opacity-50 hover:bg-opacity-80 hover:border-opacity-18"
      }`}
      style={{ borderRadius: "16px" }}
    >
      <button
        onClick={onToggle}
        className="w-full flex items-center justify-between px-7 py-5 text-left group"
        aria-expanded={isOpen}
      >
        <span
          className={`font-constantia font-bold pr-5 transition-colors duration-150 ${
            isOpen ? "text-blue-dark" : "text-blue-dark opacity-75 group-hover:opacity-100"
          }`}
          style={{ fontSize: "15.5px", lineHeight: "1.45" }}
        >
          {question}
        </span>

        <span
          className={`flex-shrink-0 w-7 h-7 rounded-full border flex items-center justify-center transition-all duration-250 ${
            isOpen
              ? "bg-blue-dark border-blue-dark text-white-pure"
              : "border-blue-dark border-opacity-20 text-blue-dark group-hover:border-opacity-40"
          }`}
          style={{
            fontSize: "17px",
            lineHeight: 1,
            transform: isOpen ? "rotate(45deg)" : "rotate(0deg)",
            transition: "transform 0.25s ease, background 0.2s, border-color 0.2s",
          }}
          aria-hidden="true"
        >
          +
        </span>
      </button>

      {/* Grid-rows animation — no max-height flash */}
      <div
        style={{
          display: "grid",
          gridTemplateRows: isOpen ? "1fr" : "0fr",
          transition: "grid-template-rows 0.28s ease",
        }}
      >
        <div style={{ overflow: "hidden" }}>
          <div className="px-7 pb-6">
            <div className="h-px bg-blue-dark opacity-8 mb-4" />
            <p
              className="font-constantia text-black-deep opacity-60 leading-relaxed"
              style={{ fontSize: "15px" }}
            >
              {answer}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default function AboutPaladinFaqsSection({ searchQuery = "" }) {
  const [openIndex, setOpenIndex] = useState(null);

  const filtered = faqs.filter(
    (faq) =>
      faq.question.toLowerCase().includes(searchQuery.toLowerCase()) ||
      faq.answer.toLowerCase().includes(searchQuery.toLowerCase())
  );

  if (filtered.length === 0) return null;

  return (
    <section id="about" className="bg-white-warm w-full py-16 px-6">
      <div className="max-w-3xl mx-auto">

        {/* Section header */}
        <div className="flex items-center gap-3 mb-8">
          <div
            className="w-px h-5 bg-blue-dark opacity-50 rounded-full"
            style={{ width: "2px" }}
          />
          <span
            className="font-cinzel text-blue-dark uppercase"
            style={{ fontSize: "10px", letterSpacing: "0.22em" }}
          >
            About Paladin
          </span>
          {searchQuery && (
            <span
              className="ml-auto font-constantia text-blue-dark opacity-35"
              style={{ fontSize: "11px" }}
            >
              {filtered.length} result{filtered.length !== 1 ? "s" : ""}
            </span>
          )}
        </div>

        <div className="flex flex-col gap-3">
          {filtered.map((faq, index) => (
            <FaqItem
              key={index}
              question={faq.question}
              answer={faq.answer}
              isOpen={openIndex === index}
              onToggle={() => setOpenIndex(openIndex === index ? null : index)}
            />
          ))}
        </div>
      </div>
    </section>
  );
}